import { RequestBasePageId, RequestBaseSet } from "@myapp/modules/fwcore/models/messages/request-base";
import { ResponseBasePage, ResponseBaseSet } from "@myapp/modules/fwcore/models/messages/response-base";
import { License } from "../license";

export class RequestLicense extends RequestBasePageId {

  companyId?: string | null;
  companyFilter?: string | null;
  licenseExpiration?: Date | null;
  active?: boolean | null;

}

export class RequestLicenseSet extends RequestBaseSet<License>
{

}

export class ResponseLicense extends ResponseBasePage<License> {

}

export class ResponseLicenseSet extends ResponseBaseSet<License>{

}
